import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";

import FlexHelpers from "@eisinc/XDL/Helpers/flex";
import SpaceHelpers from "@eisinc/XDL/Helpers/spaces";
import { HelpersGroup } from "@eisinc/XDL/types";

const Helpers = {
    ...SpaceHelpers,
    ...FlexHelpers,
} as HelpersGroup;

export const xClass = (content: TemplateStringsArray, ...keys: any[]) => {
    const regex = /(?:([a-zA-Z]*)\:+)?([a-zA-Z]+)\-?([a-zA-Z0-9]*)/g;

    return (props: any) => {
        let match: any = null;
        const css: string[] = [];

        // eslint-disable-next-line no-cond-assign
        while ((match = regex.exec(String(content)))) {
            const [, screen, method, suffix] = match;
            if (Helpers[method]) {
                css.push(Helpers[method](props.theme.helpers, suffix || "md"));
            } else {
                throw new Error(`The helper ${method} not found.`);
            }
        }

        return css.join("");
    };
};

export const screen = (action: string, size: string) => {
    const points = ["xs", "sm", "md", "lg", "xl"];
    const media: any[] = [null, null, null, null, null];
    let option: keyof typeof mediaOptions;
    let isEqual = false;

    if (["lt", "lte"].indexOf(action) !== -1) {
        option = "max";
    } else if (["gt", "gte"].indexOf(action) !== -1) {
        option = "min";
    } else {
        option = "minMax";
    }

    if (["lte", "gte"].indexOf(action) !== -1) {
        isEqual = true;
    }

    return (content: TemplateStringsArray, ...keys: any[]) => {
        let idx = points.indexOf(size);
        if (!isEqual && option === "max" && idx !== 0) {
            idx--;
        }
        if (!isEqual && option === "min" && idx !== 4) {
            idx++;
        }

        media[idx] = content.reduce((result, current, idx) => {
            return result + current + (keys[idx] || "");
        }, "");

        return (props: any) => {
            return breakpointMediaQueries(props.theme, media, option);
        };
    };
};
